import React, { useMemo, useState } from "react";
import OrgDesignRoleBoxNode from "./OrgDesignRoleBoxNode";
import { summarizeSubtreeStatuses } from "../orgDesignTreeEngine";

// Collapse state is local to each node instance — no cross-node interaction
// is required, so there's no need to lift it into shared state. It resets on
// remount (e.g. reopening a version or coming back to Org View).
// `expandedDepth` sets where it starts: nodes shallower than it start
// expanded, deeper ones collapsed (Org View passes ORG_VIEW_EXPANDED_DEPTH).
// Left out, as the PDF capture and the PAIC preview do, the whole tree
// starts expanded. `depth` is this node's level, 0 for a top-level role.
const OrgDesignChartNode = ({ node, editable, onEdit, roles, newRoles, entryOption, expandedDepth, depth = 0 }) => {
  const hasChildren = node.ch?.length > 0;
  const [collapsed, setCollapsed] = useState(() => hasChildren && expandedDepth != null && depth >= expandedDepth);
  // Memoized: it walks the whole hidden subtree, and both charts re-render
  // on every synced scroll.
  const changeSummary = useMemo(
    () => (collapsed && hasChildren ? summarizeSubtreeStatuses(node) : null),
    [collapsed, hasChildren, node]
  );

  return (
    <li>
      <OrgDesignRoleBoxNode
        node={node}
        editable={editable}
        onEdit={onEdit}
        roles={roles}
        newRoles={newRoles}
        hasChildren={hasChildren}
        collapsed={collapsed}
        onToggleCollapse={() => setCollapsed((c) => !c)}
        changeSummary={changeSummary}
        entryOption={entryOption}
      />
      {hasChildren && !collapsed && (
        <ul>
          {node.ch.map((child) => (
            <OrgDesignChartNode
              key={child.id}
              node={child}
              editable={editable}
              onEdit={onEdit}
              roles={roles}
              newRoles={newRoles}
              entryOption={entryOption}
              expandedDepth={expandedDepth}
              depth={depth + 1}
            />
          ))}
        </ul>
      )}
    </li>
  );
};

export default OrgDesignChartNode;
